import React from 'react';

import { Box } from '@mui/material';
import DGVLogo from '../../assets/images/DGV_Logo.png';


const topNavSize = {
    height: 69,
    width: 176,
    maxHeight: { xs: 69, md: 69 },
    maxWidth: { xs: 176, md: 176 },
    mb: 0
} as const;

const defaultSize = {
    height: 94,
    width: 240,
    maxHeight: { xs: 94, md: 94 },
    maxWidth: { xs: 240, md: 240 },
    mb: 3,
} as const;


function DGVMetricsLogo({ topNavLogo }: { topNavLogo: boolean }) {
    return (
        <Box
            component="img"
            sx={[
                { ...defaultSize },
                topNavLogo && { ...topNavSize }
            ]}
            alt='DGV Logo'
            src={DGVLogo}
        />
    )
}

export default DGVMetricsLogo
